module.exports = __webpack_public_path__ + "img/weather33.b8a8d86b.png";